<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Ecolpore",
        para: "Ecoplore is a travel booking website, providing eco-friendly travel packages. I did UI/UX design for the website. Tried adding a consistent lush green eco-friendly feel to a smooth user journey. Thankful to the design team at Cobold who helped in the initial design phase for the project.",
        company: "Ecoplore",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/ecoplore/cover.jpg",
        TwoImgleft: "/img/gallery/ui/ecoplore/twoimg.svg",
        TwoImgRight: "/img/gallery/ui/ecoplore/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/ecoplore/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/ecoplore/threeright.svg",
        coverimg2: "/img/gallery/ui/ecoplore/cover2.jpg",
      },
    };
  },
};
</script>
